import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import navItems from "../DashboardAdmin/navBarItems";
import UpdateIcon from "@mui/icons-material/Update";
import axios from "axios";
import { baseURL } from "../../http";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import { getUtcTime, getCurrentDateTime } from "../Common/Utilities_Function";
import { IconButton, CircularProgress, Button, Checkbox } from "@mui/material";
import { customAlert } from "../SweetAlertCommon/Custom";

function GrantAccess2({
  GiveAccesModalStatus,
  close,
  selectedRowId,
  loginData,
  role,
  SetDataBaseUpdate,
  editData,
}) {
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [accessTabs, setAccessTabs] = useState([]);
  const [readOnlyTabs, setReadOnlyTabs] = useState([]);

  //--------------------------------------------------------------------------------
  //when the editdata pesent prefill the Fileds
  //--------------------------------------------------------------------------------
  useEffect(() => {
    if (editData) {
      if (editData.DefaultAccessTabs) {
        const parsedTabIds = JSON.parse(editData.DefaultAccessTabs);
        setAccessTabs(parsedTabIds);
      }
      if (editData.ReadOnlyAccessTabs) {
        const parsedReadOnlyTabs = JSON.parse(editData.ReadOnlyAccessTabs);
        setReadOnlyTabs(parsedReadOnlyTabs);
      }
    }
  }, [editData]);
  //--------------------------------------------------------------------------------
  //SEt the Access for the tab and readonly tabs
  //--------------------------------------------------------------------------------
  useEffect(() => {
    if (loginData && loginData.length > 0) {
      const user = loginData.find((user) => user.id === selectedRowId);
      setSelectedUser(user);
      setLoading(false);

      const parseArrayFromString = (str) => {
        try {
          // Remove the first and last double quotes if they exist
          const cleanedStr = str.replace(/^"|"$/g, "");
          // Parse the cleaned string into a JSON array
          const parsedArray = JSON.parse(cleanedStr);
          return Array.isArray(parsedArray) ? parsedArray : [];
        } catch (error) {
          console.error("Failed to parse array:", error);
          return [];
        }
      };

      if (user && user.tabids) {
        const parsedTabIds = parseArrayFromString(user.tabids);
        setAccessTabs(parsedTabIds);
      } else {
        setAccessTabs([]);
      }

      if (user && user.readonlytabs) {
        const parsedReadOnlyTabs = parseArrayFromString(user.readonlytabs);
        setReadOnlyTabs(parsedReadOnlyTabs);
      } else {
        setReadOnlyTabs([]);
      }
    } else {
      setLoading(false);
    }
  }, [loginData, selectedRowId, GiveAccesModalStatus]);

  console.log("accessTabs", accessTabs);
  console.log("readOnlyTabs", readOnlyTabs);

  //--------------------------------------------------------------------------------
  //close the modal
  //--------------------------------------------------------------------------------
  const handleCloseGiveAccess = () => {
    setReadOnlyTabs([]);
    setAccessTabs([]);
    close(false);
  };

  //--------------------------------------------------------------------------------
  //Tabs check box click function
  //--------------------------------------------------------------------------------
  const handleCheckboxChange = (mainId, subId = null) => {
    setAccessTabs((prevTabs) => {
      const newTabs = [...prevTabs];
      const mainTabIndex = newTabs.findIndex((tab) => tab[0] === mainId);

      if (subId === null) {
        if (mainTabIndex === -1) {
          newTabs.push([mainId]);
        } else {
          newTabs.splice(mainTabIndex, 1);
        }
      } else {
        if (mainTabIndex === -1) {
          newTabs.push([mainId, subId]);
        } else {
          const subTabIndex = newTabs[mainTabIndex].indexOf(subId);
          if (subTabIndex === -1) {
            newTabs[mainTabIndex].push(subId);
          } else {
            newTabs[mainTabIndex].splice(subTabIndex, 1);
            if (newTabs[mainTabIndex].length === 1) {
              newTabs.splice(mainTabIndex, 1);
            }
          }
        }
      }

      return newTabs;
    });
  };

  //--------------------------------------------------------------------------------
  //Raed only checkbox clikc function
  //--------------------------------------------------------------------------------
  const handleReadAccessChange = (mainId, subId = null) => {
    setReadOnlyTabs((prevTabs) => {
      const newTabs = [...prevTabs];
      const mainTabIndex = newTabs.findIndex((tab) => tab[0] === mainId);

      if (subId === null) {
        if (mainTabIndex === -1) {
          newTabs.push([mainId]);
        } else {
          newTabs.splice(mainTabIndex, 1);
        }
      } else {
        if (mainTabIndex === -1) {
          newTabs.push([mainId, subId]);
        } else {
          const subTabIndex = newTabs[mainTabIndex].indexOf(subId);
          if (subTabIndex === -1) {
            newTabs[mainTabIndex].push(subId);
          } else {
            newTabs[mainTabIndex].splice(subTabIndex, 1);
            if (newTabs[mainTabIndex].length === 1) {
              newTabs.splice(mainTabIndex, 1);
            }
          }
        }
      }

      return newTabs;
    });
  };

  //--------------------------------------------------------------------------------
  //Post methode calling
  //--------------------------------------------------------------------------------
  const handleSubmitAccesstabs = async () => {
    try {
      await axios.post(baseURL + "/Roll_Default_Tabs", {
        UserRole: role,
        DefaultAccessTabs: JSON.stringify(accessTabs),
        ReadOnlyAccessTabs: JSON.stringify(readOnlyTabs),
        Created_by: localStorage.getItem("HTES_user_id"),
        Modified_by: localStorage.getItem("HTES_user_id"),
        UTC_Time: getUtcTime(),
        Modified_date: getCurrentDateTime(),
        Created_date: getCurrentDateTime(),
      });
      customAlert("", "New Role Default Access Tabs Created", "success");
      SetDataBaseUpdate(true);
      handleCloseGiveAccess();
    } catch (error) {
      console.error("Error updating tabs:", error);
    }
  };

  //--------------------------------------------------------------------------------
  //Update methode calling
  //--------------------------------------------------------------------------------

  const handleUpdateAccesstabs = async () => {
    try {
      await axios.put(baseURL + `/Roll_Default_Tabs_update/${editData.id}`, {
        UserRole: editData.UserRole,
        DefaultAccessTabs: JSON.stringify(accessTabs),
        ReadOnlyAccessTabs: JSON.stringify(readOnlyTabs),
        Modified_by: localStorage.getItem("HTES_user_id"),
        UTC_Time: getUtcTime(),
        Modified_date: getCurrentDateTime(),
      });
      customAlert(
        "",
        `${editData.UserRole} Default Role Access Updated`,
        "success"
      );
      SetDataBaseUpdate(true);
      setReadOnlyTabs([]);
      setAccessTabs([]);
      handleCloseGiveAccess();
    } catch (error) {
      console.error("Error updating tabs:", error);
    }
  };

  //--------------------------------------------------------------------------------
  //Render the tabs and Subtabs
  //--------------------------------------------------------------------------------

  const filteredItems = navItems
    .map((item) => {
      const isMainItemIncluded = accessTabs.some((tab) => tab[0] === item.id);

      const filteredSubItems = item.subItems
        ? item.subItems.filter(
            (subItem) => !accessTabs.some((tab) => tab.includes(subItem.id))
          )
        : [];

      if (filteredSubItems.length === 0 && isMainItemIncluded) {
        return null;
      }

      return {
        ...item,
        subItems: filteredSubItems,
      };
    })
    .filter((item) => item !== null);

  return (
    <>
      <Modal
        open={GiveAccesModalStatus}
        onClose={handleCloseGiveAccess}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="giveaccessmodaloutercontainer"
      >
        <div className="giveaccessmodaloutercontainer">
          <div className="filtermodalcontent-grant-access2">
            <div>
              <IconButton
                id="button-zoom"
                className="EducationalTableViewmodalcloseicon"
                onClick={handleCloseGiveAccess}
              >
                <CloseIcon className="EducationalTableViewmodalcloseiconX" />
              </IconButton>
            </div>
            {loading ? (
              <div className="loading-container">
                <CircularProgress />
              </div>
            ) : (
              <div>
                {/* __________header________________ */}
                <div className="filterheaderdiv-grant-access2">
                  <h5 className="filterheader">
                    {role || editData.UserRole}-Default Tabs Access
                  </h5>
                </div>
                {/*______________Granted access tab fucntions______________ */}
                <div className="devide-two-conatiner-grid-grant-access2">
                  <div className="grid-main-container">
                    <h5 className="Heading-for-the-grids">
                      {" "}
                      Acces Granted Tabs
                    </h5>
                    <div className="giveaccesscrollcontainerNavbar-grantAccess2">
                      {accessTabs.length > 0 ? (
                        accessTabs.map((tabids, index) => {
                          const item = navItems.find(
                            (item) => item.id === tabids[0]
                          );
                          if (item) {
                            return (
                              <div
                                className="giveaccessccontentcontainer-grant-access2"
                                key={index}
                              >
                                <div className="subitem-content-grantAccess2">
                                  <div>
                                    <Checkbox
                                      checked={true}
                                      onChange={() =>
                                        handleCheckboxChange(item.id)
                                      }
                                    />
                                    &nbsp;
                                    <span className="tabnamefont">
                                      {item.title}
                                    </span>
                                  </div>
                                  {!item.subItems?.length && (
                                    <div className="subitem-permissions">
                                      <label className="subitem-permissions">
                                        <Checkbox
                                          checked={readOnlyTabs.some(
                                            (tab) => tab[0] === item.id
                                          )}
                                          onChange={() =>
                                            handleReadAccessChange(item.id)
                                          }
                                        />
                                        <span>Read Only</span>
                                      </label>
                                    </div>
                                  )}
                                </div>
                                {tabids.length > 1 && (
                                  <div className="subitems-container-grantAccess2">
                                    {tabids.slice(1).map((subTabId) => {
                                      const subItem = item.subItems.find(
                                        (sub) => sub.id === subTabId
                                      );
                                      return (
                                        <div
                                          className="subitem-content-grantAccess2"
                                          key={subTabId}
                                        >
                                          <div>
                                            <Checkbox
                                              checked={true}
                                              onChange={() =>
                                                handleCheckboxChange(
                                                  item.id,
                                                  subTabId
                                                )
                                              }
                                            />
                                            &nbsp;
                                            <span className="tabnamefont">
                                              {subItem.subtitle}
                                            </span>
                                          </div>
                                          <div>
                                            <div className="subitem-permissions">
                                              <label className="subitem-permissions">
                                                <Checkbox
                                                  checked={readOnlyTabs.some(
                                                    (tab) =>
                                                      tab[0] === item.id &&
                                                      tab.includes(subTabId)
                                                  )}
                                                  onChange={() =>
                                                    handleReadAccessChange(
                                                      item.id,
                                                      subTabId
                                                    )
                                                  }
                                                />
                                                <span>Read Only</span>
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </div>
                            );
                          }
                          return null;
                        })
                      ) : (
                        <div className="notabscinatainer">
                          No access tabs selected
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="devider"></div>
                  {/* __________________available tabs function___________________ */}
                  <div className="grid-main-container1">
                    <h5 className="Heading-for-the-grids">Available Tabs</h5>
                    <div className="giveaccesscrollcontainerNavbar-grantAccess2">
                      {filteredItems.map((item) => (
                        <div
                          className="giveaccessccontentcontainer-grant-access2"
                          key={item.id}
                        >
                          <div className="subitem-content-grantAccess2">
                            <div>
                              {item.subItems.length === 0 && (
                                <Checkbox
                                  checked={false}
                                  onChange={() => handleCheckboxChange(item.id)}
                                />
                              )}
                              &nbsp;
                              <span className="tabnamefont">{item.title}</span>
                            </div>
                          </div>
                          {item.subItems && item.subItems.length > 0 && (
                            <div className="subitems-container-grantAccess2">
                              {item.subItems.map((subItem) => (
                                <div
                                  className="subitem-content-grantAccess2"
                                  key={subItem.id}
                                >
                                  <div>
                                    <Checkbox
                                      checked={false}
                                      onChange={() =>
                                        handleCheckboxChange(
                                          item.id,
                                          subItem.id
                                        )
                                      }
                                    />
                                    &nbsp;
                                    <span className="tabnamefont">
                                      {subItem.subtitle}
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* __________________Button section______________________ */}
                <div className="giveaccesalignmetbutton-role-access">
                  <div>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={
                        editData && editData.id
                          ? handleUpdateAccesstabs
                          : handleSubmitAccesstabs
                      }
                      id="button-zoom"
                    >
                      {editData && editData.id ? (
                        <UpdateIcon className="buttonicons" />
                      ) : (
                        <LibraryAddCheckIcon className="buttonicons" />
                      )}
                      {editData && editData.id ? (
                        <span>&nbsp;Update Default Access</span>
                      ) : (
                        <span>&nbsp;Grant Default Access</span>
                      )}
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}

export default GrantAccess2;
